<template>
    <div class="q-col-gutter-md" style="margin-top: -42px;">
        <template v-for="(elements, index) in trends">
            <div class="row q-col-gutter-md">
                <div v-for="(trend, i) in elements" class="col-12 col-sm-6 col-md-4 col-lg-3"
                     @click="reviewTrend(trend, index, i)">
                    <div :class="['trend-card', {'active-trend': selectedElement(index, i)}]"
                         :style="`background-image: url(${trend.thumbnail_path ? trend.thumbnail_path : trend.image_path})`">
                        <h4 class="trend-card-title">{{ trend.title }}</h4>
                        <p class="trend-card-text" v-html="trend.short_description"></p>
                        <div class="border"></div>
                    </div>
                </div>
            </div>
            <q-card v-if="selectedTrend[index]" class="trends-details">
                <div @click="closeTrend(index)" class="modal-close mt-3">
                    <span aria-hidden="true">
                        <svg x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10"
                             enable-background="new 0 0 10 10" xml:space="preserve">
                            <path fill=""
                                  d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                        </svg>
                    </span>
                </div>
                <q-card-section>
                    <div class="trends-container">
                        <div class="trends-left">
                            <div class="trend-img"
                                 :style="'background-image: url(' + selectedTrend[index].image_path + ')'"></div>
                        </div>
                        <div class="trends-right">
                            <div class="trend-content">
                                <div class="trend-content-description mt-4 mb-2">
                                    <h4 class="trend-content-description-title">{{ selectedTrend[index].title }}</h4>
                                    <div v-html="selectedTrend[index].description"
                                         class="trend-content-description-text"></div>
                                </div>
                                <div class="carousel trends-carousel trend-content-examples">
                                    <carousel classes="slides-3" ref="carousel" :items="selectedProducts(index)" :options="options" :show-navigation="showNavigation(index)">
                                        <template #slide="{ item }">
                                            <card :product="item"></card>
                                        </template>
                                    </carousel>
                                </div>
                            </div>
                            <q-btn color="secondary" v-if="hasLink" label="В каталог" @click.prevent="goToCatalog"/>
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </template>
    </div>
</template>

<script>
import windowWidth from "../../mixins/windowWidth";
import Carousel from "../Carousel/Carousel";

export default {
    name: "Trends",
    props: {
        initTrends: {
            type: Array,
            required: true
        },
    },
    mixins: [
        windowWidth,
    ],
    components: {
        Carousel,
    },
    data() {
        return {
            trends: [],
            trendReview: false,
            selectedTrend: [],
            selected: {},
            options: {
                spaceBetween: 5,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                    },
                    320: {
                        slidesPerView: 2,
                    }
                },
            }
        }
    },
    mounted() {
        this.$set(this, 'trends', _.chunk(this.initTrends, this.elementCount));
    },
    computed: {
        hasLink() {
            let trend = _.first(this.selectedTrend);
            return (trend && trend.link);
        },
        elementCount() {
            let el = 1;

            if (this.windowWidth > 1440) {
                el = 4;
            } else if (this.windowWidth > 1024) {
                el = 3;
            } else if (this.windowWidth > 600) {
                el = 2;
            }
            return el;
        },
    },
    methods: {
        selectedProducts(index) {
            return this.selectedTrend[index].products;
        },
        showNavigation(index) {
            return this.selectedProducts(index).length > 3;
        },
        reviewTrend(trend, index, i) {
            this.selectedTrend = [];

            this.$set(this, 'trends', _.chunk(this.initTrends, this.elementCount));
            this.$set(this.selectedTrend, index, trend);

            this.selected = {};
            this.$set(this.selected, index, i);

            setTimeout(this.scrollToTrendContent, 100);
        },
        closeTrend(index) {
            this.selectedTrend = [];
            this.selected = {};
        },
        selectedElement(index, i) {
            return _.get(this.selected, index) === i;
        },
        scrollToTrendContent() {
            let element = document.querySelector('.trends-container');
            element.scrollIntoView({block: "center", behavior: "smooth"});
        },
        goToCatalog() {
            let trend = _.first(this.selectedTrend);

            if (trend && trend.link) {
                window.location.href = trend.link;
            }
        },
    }
}
</script>
